




















































































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import * as s_Interface from '@/interface/store/manageGroups';
import { validateURL } from '@/utils/validate';
import { openSuggestions } from '@/utils/common';

const namespace: string = 'request';

@Component
export default class ModalStatusPending extends Vue {
  @PropSync('dialogVisibleStatus', { type: Boolean }) syncedDialogVisibleStatus!: boolean;
  @Prop({ type: Array, default: [] }) orderStatusItems!: any;

  @Action('setRequestBulk', { namespace }) c_setRequestBulk!: any;
  @Action('updateRequestStatus', { namespace }) c_updateRequestStatus!: any;
  @Action('setVendor', { namespace: 'manageGroup' }) c_setVendor!: any;
  @Action('setManufacturer', { namespace: 'manageGroup' }) c_setManufacturer!: any;
  @Action('getVendors', { namespace: 'manageGroup' }) c_getVendors!: any;
  @Action('getManufacturers', { namespace: 'manageGroup' }) c_getManufacturers!: any;

  @Getter('getterVendors', { namespace: 'manageGroup' }) c_getterVendors!: Array<
    s_Interface.VendorData
  >;
  @Getter('getterManufacturers', { namespace: 'manageGroup' }) c_getterManufacturers!: Array<
    s_Interface.ManufacturerData
  >;

  public isLoading: boolean = false;
  public validateURL: Function = validateURL;
  public openSuggestions: Function = openSuggestions;
  public changeVendorInput: boolean = false;
  public changeManufacturerInput: boolean = false;
  public selectIdx: number = 0;
  public rules: any = {
    name: [
      { required: true, message: '물품명을 입력해주세요.', trigger: 'blur' },
      { max: 150, message: '물품명은 150자를 넘을 수 없습니다.', trigger: ['blur', 'change'] },
    ],
    vendorName: { message: '판매처를 입력해주세요.', trigger: ['blur', 'change'] },
    manufacturerName: {
      message: '제조사를 입력해주세요.',
      trigger: ['blur', 'change'],
    },
    catalogNumber: [
      { message: '카탈로그 번호를 입력해주세요.', trigger: 'blur' },
      {
        max: 100,
        message: '카탈로그 번호는 100자를 넘을 수 없습니다.',
        trigger: ['blur', 'change'],
      },
    ],
    typeName: { required: true, message: '타입명을 입력해주세요.', trigger: ['blur', 'change'] },
  };

  get currentTotalPrice() {
    const quantity: number = this.orderStatusItems[this.selectIdx].quantity;
    const price: number = this.orderStatusItems[this.selectIdx].price;
    const totalPrice = quantity * price;
    const commaParse = totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return isNaN(totalPrice) ? 0 : commaParse;
  }

  handleClose() {
    this.syncedDialogVisibleStatus = false;
  }

  async created() {
    const groupId: string = this.$route.params.groupId;
    this.orderStatusItems[this.selectIdx].unit = 'units';
    await this.c_getVendors(groupId);
    await this.c_getManufacturers(groupId);
  }

  next() {
    (this.$refs.requestForm as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.selectIdx++;
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }

  prev() {
    (this.$refs.requestForm as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.selectIdx--;
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }

  async submit() {
    const groupId: string = this.$route.params.groupId;
    (this.$refs.requestForm as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.isLoading = true;
          await this.c_setRequestBulk({
            groupId,
            payload: this.orderStatusItems,
          });
          this.syncedDialogVisibleStatus = false;
          this.$message.success('구매요청 하였습니다.');
          this.$emit('initLoad');
          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }

  createFilter(queryString: string) {
    return (link: any) => link.name.indexOf(queryString) === 0;
  }

  vendorQuerySearch(queryString: string, cb: any) {
    const vendorLinks = this.c_getterVendors;
    const changeVendorInput = this.changeVendorInput;
    if (changeVendorInput) {
      const results = queryString
        ? vendorLinks.filter(this.createFilter(queryString))
        : vendorLinks;
      cb(results);
    } else {
      cb(vendorLinks);
    }
  }

  vendorHandleSelect(item: any) {
    this.orderStatusItems[this.selectIdx].vendorName = item.name;
    this.orderStatusItems[this.selectIdx].fkVendorId = item.id;
    this.changeVendorInput = false;
  }

  vendorHandleInput() {
    this.changeVendorInput = true;
  }

  vendorHandleChange(queryString: any) {
    if (queryString) {
      const vendorLinks = this.c_getterVendors;
      const groupId: string = this.$route.params.groupId;
      const isNotValid = vendorLinks.filter((link: any) => link.name.includes(queryString)).length;
      if (!isNotValid) {
        this.$confirm(
          'LAB 관리 > 판매처에서 모든 판매처 목록을 관리하실 수 있습니다.',
          `'${queryString}' 판매처를 추가하시겠습니까?`,
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            try {
              const item = await this.c_setVendor({
                groupId,
                payload: {
                  name: queryString,
                },
              });
              this.orderStatusItems[this.selectIdx].vendorName = item.name;
              this.orderStatusItems[this.selectIdx].fkVendorId = item.id;
              await this.c_getVendors(groupId);
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            console.log(e);
            this.orderStatusItems[this.selectIdx].vendorName = '';
            this.orderStatusItems[this.selectIdx].fkVendorId = null;
          });
      }
    }
  }

  manufacturerQuerySearch(queryString: string, cb: any) {
    const manufacturerLinks = this.c_getterManufacturers;
    const changeManufacturerInput = this.changeManufacturerInput;
    if (changeManufacturerInput) {
      const results = queryString
        ? manufacturerLinks.filter(this.createFilter(queryString))
        : manufacturerLinks;
      cb(results);
    } else {
      cb(manufacturerLinks);
    }
  }

  manufacturerHandleSelect(item: any) {
    this.orderStatusItems[this.selectIdx].manufacturerName = item.name;
    this.orderStatusItems[this.selectIdx].fkManufacturerId = item.id;
    this.changeManufacturerInput = false;
  }

  manufacturerHandleInput() {
    this.changeManufacturerInput = true;
  }

  manufacturerHandleChange(queryString: any) {
    if (queryString) {
      const manufacturerLinks = this.c_getterManufacturers;
      const groupId: string = this.$route.params.groupId;
      const isNotValid = manufacturerLinks.filter((link: any) => link.name.includes(queryString))
        .length;
      if (!isNotValid) {
        this.$confirm(
          'LAB 관리 > 판매처에서 모든 판매처 목록을 관리하실 수 있습니다.',
          `'${queryString}' 판매처를 추가하시겠습니까?`,
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            try {
              const item = await this.c_setManufacturer({
                groupId,
                payload: {
                  name: queryString,
                },
              });
              this.orderStatusItems[this.selectIdx].manufacturerName = item.name;
              this.orderStatusItems[this.selectIdx].fkManufacturerId = item.id;
              await this.c_getManufacturers(groupId);
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            console.log(e);
            this.orderStatusItems[this.selectIdx].manufacturerName = '';
            this.orderStatusItems[this.selectIdx].fkManufacturerId = null;
          });
      }
    }
  }
}
